'use strict';

import React from 'react';

import Group from 'components/base/form-components/Group';
import ConditionalDisplay from 'components/utils/ConditionalDisplay';
import DisplayField from 'components/base/form-components/DisplayField';
import FileInput from 'services/vendors/react-file-input';

import utils from 'services/utils';


class LeaveApplyAttachments extends React.Component {
    constructor(props) {
        super(props);
        this.handleAttachmentChange = this.handleAttachmentChange.bind(this);
        this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
        this.showAttachmentError = this.showAttachmentError.bind(this);
        this.getFileExtensionToLowerCase = this.getFileExtensionToLowerCase.bind(this);
        this.updateParentElement = this.updateParentElement;
        this.state = {
            attachment: null,
            attachmentInfos: this.props.application ? this.props.application.AttachmentInfos : null,
        };
    }

    handleAttachmentChange(event) {
        var files = event.target.files;
        var file = files[0];

        //initialize default values
        if (file) {
            this.setState({
                invalidAttachment: true,
                attachmentErrorMessage: "Invalid attachment.",
            });
        } else {
            this.setState({
                invalidAttachment: false,
                attachmentErrorMessage: "Invalid attachment.",
            });
        }

        if (files && file) {
            var _state = this.state;
            _state.attachment = file;
            var reader = new FileReader();

            reader.addEventListener("load", function () {
                _state.attachment.content = reader.result.split("base64,")[1];
            }, false);

            if (file) {
                reader.readAsDataURL(file);
            }

            var extensionName = this.getFileExtensionToLowerCase(this.state.attachment.name);
            var validExtension = "jpg,jpeg,png,pdf";

            if (validExtension.indexOf(extensionName) >= 0) {
                if (file.size > 3145728) {
                    this.setState({
                        invalidAttachment: true,
                        attachmentErrorMessage: "Maximum size is 3MB.",
                    }, () => {
                        this.updateParentElement();
                    });
                } else {
                    this.setState({
                        invalidAttachment: false,
                    }, () => {
                        this.updateParentElement();
                    });
                }
            } else {
                this.setState({
                    invalidAttachment: true,
                    attachmentErrorMessage: "Only JPG/PDF/PNG files are allowed.",
                }, () => {
                    this.updateParentElement();
                });
            }
        }
    }

    handleDeleteButtonClick(event) {
        utils.preventDefault(event);
        this.setState({
            attachmentInfos : null,
        }, () => {
            this.updateParentElement();
        });
    }

    showAttachmentError() {
        if (this.state.attachment) {
            return this.state.invalidAttachment;
        } else {
            return false;
        }
    }

    getFileExtensionToLowerCase(filename) {
        return filename.substr((filename.lastIndexOf('.') + 1)).toLowerCase();
    }

    updateParentElement() {
        this.props.onUpdateCallback({
            attachment: this.state.attachment,
            attachmentInfos: this.state.attachmentInfos,
            invalidAttachment: this.state.invalidAttachment,
        });
    }

    render() {
        return (
            <Group>
                <ConditionalDisplay test={!this.props.isEditMode || this.state.attachmentInfos === null}>
                    <div id={'form-element-{0}'.format(this.props.name)} className="fc-input fileInput">
                        <label>Attachment</label>
                        <FileInput
                            id={this.props.name}
                            name="attachmentname"
                            accept=".png,.jpg,.jpeg,.pdf"
                            ref="attachment"
                            className="fileInput"
                            onChange={this.handleAttachmentChange}
                        />
                        <i className="icon-attachments attachments-icon" />
                        <ConditionalDisplay test={this.showAttachmentError()}>
                            <p className="error">{this.state.attachmentErrorMessage}</p>
                        </ConditionalDisplay>
                    </div>
                </ConditionalDisplay>
                <ConditionalDisplay test={this.props.isEditMode && this.state.attachmentInfos !== null}>
                    <div id={this.props.name} className="fc-input fileInput">
                        <label>Attachment</label>
                        {this.state.attachmentInfos ? <DisplayField name="Name" value={this.state.attachmentInfos[0].Name} /> : null}
                        <button className="button--plain" onClick={this.handleDeleteButtonClick}><i className="icon-delete" /></button>
                    </div>
                </ConditionalDisplay>
            </Group>
        );
    }
}

export default LeaveApplyAttachments; 
